import { mainAPI, handleApiError } from "../api";

import { ReviewResponse, ReviewsRequest } from "../types/api/review";
import { ApiErrorResponse } from "../types/api/error";

const path = `/reviews/admin/${process.env.REACT_APP_API_VERSION}`;

// Скрытые отзывы на покупателей - Получить список
export function fetchHiddenReviewsList(params: ReviewsRequest, id: string) {
  return mainAPI
    .get<ReviewResponse[]>(`${path}/hidden-reviews/` + id, { params })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}

// Публичные отзывы на владельцев - Получить список
export function fetchPublicReviewsList(params: ReviewsRequest, id: string) {
  return mainAPI
    .get<ReviewResponse[]>(`${path}/public-reviews/` + id, { params })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}
// Отзыв - Получить запись
export function fetchReview(id: string) {
  const url = `/reviews/${process.env.REACT_APP_API_VERSION}`;

  return mainAPI.get(`${url}/${id}`).then(
    (res) => {
      return Promise.resolve(res.data as ReviewsRequest);
    },
    (error) => handleApiError(error)
  );
}
// Отзыв - Удалить
export function deleteReview(id: string) {
  const url = `/reviews/${process.env.REACT_APP_API_VERSION}`;

  return mainAPI.delete(`${url}/delete/${id}`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(
        new Error(apiError?.detail || "Ошибка при удалении отзыва")
      );
    }
  );
}
